module.exports = __webpack_public_path__ + "img/nubila.e6c08b5f.svg";